import { useState, useEffect } from 'react';
import { IonContent, IonPage, IonImg, useIonViewWillEnter } from '@ionic/react';
import { Storage } from '@capacitor/storage';
import { App as CapacitorApp } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import Auth from '../components/profile/modals/Auth';
import Links from '../components/profile/Links';
import Dashboard from '../components/profile/Dashboard';
import './Profile.css';
import userAvatarImg from '../assets/images/user-avatar.svg';

const Profile = () => {
    const [isLogin, setIsLogin] = useState(false);
    const [userData, setUserData] = useState({}) as any;
    useIonViewWillEnter(() => {
        const getUserData = async () => {
            const { value } = await Storage.get({ key: 'userData' });
            if (value) {
                const objectValue = JSON.parse(value);
                setUserData(objectValue);
                setIsLogin(true);
            } else {
                setUserData({});
                setIsLogin(false);
            }
        }
        getUserData();
    })
    const handleLogoutCallback = (childData: boolean) => {
        setIsLogin(false);
    }
    const handleIsLoginCallback = (childData: boolean) => {
        setIsLogin(true);
    }
    const [appInfo, setAppInfo] = useState({}) as any;
    useEffect(() => {
        const getAppInfo = async () => {
            const appInfo = await CapacitorApp.getInfo();
            setAppInfo(appInfo);
        }
        getAppInfo();
    }, [])
    return (
        <IonPage className="page-padding-top">
            <IonContent fullscreen>
                <div className="ion-padding">
                    {isLogin ?
                        <Dashboard logoutParentCallback={handleLogoutCallback} userData={userData} />
                        :
                        <div className="auth-box-container">
                            <div>
                                <IonImg src={userAvatarImg} />
                                <h6>ورود / ثبت نام</h6>
                            </div>
                            <p>
                                برای بهره مندی از امکانات بیشتر وارد حساب کاربری خود شوید.
                            </p>
                            <Auth isLoginParentCallback={handleIsLoginCallback} />
                        </div>
                    }
                    <Links />
                    <div className="app-version-label">
                        {Capacitor.isNativePlatform() ?
                            "Version " + appInfo.version
                            :
                            "Version 1.0.6"
                        }
                    </div>
                </div>
            </IonContent>
        </IonPage>
    );
};

export default Profile;